import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../Generic/SearchPage/actions/searchPageActions';
import { getUserRestriction } from '../../../../services/AuthService/AuthService';
import invoiceApi from '../../../../services/api/InvoiceApi';
import { ObjectTypes } from '../../../../utils/constants';
import { invoiceSearchActions as searchPageSliceActions } from '../slices/invoiceSearchSlice';

const getStateSliceForSearchPage = (state) => state.invoiceSearch;
export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns: ObjectTypes.InvoiceSearchGrid
});

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction({ dispatch, getState, searchPageSliceActions, getStateSliceForSearchPage, objectTypeForSaveUserFilter: ObjectTypes.InvoiceSearchUserFilter });

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const state = getState();

  const {
    assignedLocations,
    assignedSourceSystems,
    assignedClients,
    assignedProjects,
    isPetroHubUser
  } = getUserRestriction(state.auth);

  const searchParamBuilder = (filter) => {
    const queryFilter = {
      invoiceNumber: filter.InvoiceNumber,
      jobName: filter.JobName,
      invoiceType: filter.Type?.text ? filter.Type.text : null,
      invoiceDateFrom: filter.DateFrom,
      invoiceDateTo: filter.DateTo,
      locationID: filter.Location ? [filter.Location?.LocationID || filter?.Location?.id] : null,
      sourceSystemIDs: assignedSourceSystems,
      projects: assignedProjects,
      locationIDs: assignedLocations,
      isPetroHubUser
    };
    if (isPetroHubUser) {
      return {
        ...queryFilter,
        clientIDs: filter.clientIDs ?? []
      };
    }
    return {
      ...queryFilter,
      clientID: filter.Client ? [filter.Client?.ClientID || filter?.Client?.id] : null,
      clientIDs: assignedClients,
    };
  };

  await doSearchStoreAction({
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    searchWithPaginationApi: invoiceApi.searchInvoices,
    postResultsProcessHandler: null
  });
};
